export default "__VITE_ASSET__B$YAutrT__"